import { apiClient } from '../../../api-client';
import type { ContactFormValues } from '../types/contactTypes';

export async function submitContactForm(values: ContactFormValues): Promise<void> {
  await apiClient.community.contactSubmission({
    first_name: values.first_name,
    last_name: values.last_name,
    email: values.email,
    message: values.message,
  });
}
